<template>
	<a :href="baseURL">
		<img src="../assets/logo.svg" alt class="logo" v-bind="$attrs" />
	</a>
</template>

<script>
export default {
	name: "AppLogo",
	inheritAttrs: false,
	computed: {
		baseURL() {
			return this.$router.options.base;
		}
	}
};
</script>

<style lang="scss">
.logo {
	margin-bottom: 2em;
	max-width: 320px;
}
</style>
